import { dsLogger } from '../../shared/services/logger/logger.instance';

export const sideMenuLogger = dsLogger.extend('side-menu');
